import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Privacy() {
  const { t } = useTranslation();

  const sectionStyle = {
    marginBottom: '1.5rem',
  };
  const headingStyle = {
    fontFamily: "'Oswald', sans-serif",
    fontSize: '1rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'var(--orange)',
    marginBottom: '0.5rem',
  };
  const bodyStyle = {
    fontSize: '0.9rem',
    lineHeight: 1.7,
    color: 'var(--text-muted)',
  };

  return (
    <div style={{
      maxWidth: '720px',
      margin: '0 auto',
      padding: '2rem 1.5rem 4rem',
      background: 'var(--bg-base)',
      minHeight: '60vh',
    }}>
      <h1 style={{
        fontFamily: "'Bebas Neue', sans-serif",
        fontSize: '2.5rem',
        letterSpacing: '0.12em',
        color: '#ffffff',
        marginBottom: '0.25rem',
      }}>
        {t('privacy.title')}
      </h1>
      <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '2rem' }}>
        {t('privacy.lastUpdated')}
      </p>

      <section style={sectionStyle}>
        <p style={bodyStyle}>{t('privacy.intro')}</p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>{t('privacy.dataWeCollect')}</h2>
        <p style={bodyStyle}>{t('privacy.dataWeCollectBody')}</p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>{t('privacy.phoneWhatsApp')}</h2>
        <p style={bodyStyle}>{t('privacy.phoneWhatsAppBody')}</p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>{t('privacy.bookingData')}</h2>
        <p style={bodyStyle}>{t('privacy.bookingDataBody')}</p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>{t('privacy.howWeUse')}</h2>
        <p style={bodyStyle}>{t('privacy.howWeUseBody')}</p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>{t('privacy.retention')}</h2>
        <p style={bodyStyle}>{t('privacy.retentionBody')}</p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>{t('privacy.rights')}</h2>
        <p style={bodyStyle}>{t('privacy.rightsBody')}</p>
      </section>

      <section style={sectionStyle}>
        <p style={bodyStyle}>{t('privacy.contact')}</p>
      </section>

      <p style={{ marginTop: '2rem' }}>
        <Link
          to="/"
          style={{
            fontFamily: "'Oswald', sans-serif",
            fontSize: '0.85rem',
            fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: 'var(--orange)',
            textDecoration: 'none',
          }}
        >
          {t('privacy.backToHome')}
        </Link>
      </p>
    </div>
  );
}
